import { Route, Routes } from "react-router-dom";
import ListPage from "./list";

export default function FileRouter() {
  return (
    <Routes>
      <Route path="" element={<ListPage />} />
    </Routes>
  );
}
